import type { TextFieldProps } from "@mui/material/TextField";
import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { Setup as SetupType } from "features/setups/types";
import type { selectSetupActiveCompany, selectSetupGroupNames } from "features/general/selectors";
import type { AutocompleteProps } from "ui/atoms/Autocomplete";
import type { ISetupValue } from "./SetupValue";

export const enum FormField {
    Identifier = 'identifier',
    Mor = 'MOR',
    ValueType = 'valueType',
    CreatedBySystem = 'createdBySystem',
    IsDeletable = 'isDeletable',
    SetupValue = 'setupValue',
    SetupInputValue = 'setupInputValue',
    Obs = 'obs',
    GroupName = 'groupName'
};

export type Setup<T extends unknown = unknown> = Pick<
    SetupType<string>,
    | "identifier"
    | "valueType"
    | "createdBySystem"
    | "isDeletable"
    | "coreId"
    | "obs"
    | 'MOR'
    | "groupName"
> & {
    readonly setupValue: ISetupValue<T>;
    readonly setupInputValue: SetupType<string>['setupValue'];
};

export type SetupForm = Omit<BootstrapableForm<Setup, {}>, 'initialValues'> & {
    readonly initialValues: Setup;
};

export type OverrideProps = {
    readonly [FormField.Identifier]: Partial<TextFieldProps>;
    readonly [FormField.Mor]: Partial<AutocompleteProps>;
};

export type SetupFormReturnType<T extends unknown> = ReturnType<typeof useForm<Setup<T>>>;

export type SetupProps =
    & SetupForm
    & ReturnType<typeof useForm<Setup>>
    & {
        readonly selectSetupActiveCompany: typeof selectSetupActiveCompany;
        readonly setUpGroupNameOptions: typeof selectSetupGroupNames;
        readonly overrideProps?: OverrideProps;
    };
